module.exports = __webpack_public_path__ + "static/media/8.27cf1b82.JPG";